import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Input} from "@nextui-org/react";
import axios from "axios";
import { users_uri } from "../../../../utils/url";
import { toast } from "react-toastify";

export default function DeleteModal({datas, callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [data, setData] = useState({phone: datas.phone_no, deposit: datas.deposit});
  const [load, setLoad] = useState(false);

  const handlecall = () => {
    callback();
  }

  const submit = async() => {
    setLoad(true);
    try{
        const res = await axios.delete(users_uri+'/delete'+`?id=${datas.id}`);
        if(res.status === 200){
            toast.success("Амжилттай устгалаа");
            handlecall();
        }
        setLoad(false);
    }catch(err){
        setLoad(false);
        console.log(err);
    }
  }

  return (
    <>
      <Button className="bg-red-500 text-white" size="sm" onPress={onOpen}>Устгах</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Та {data.phone} дугаартай хэрэглэгчийг устгах гэж байна ?</ModalHeader>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                {
                    load?
                    <Button color="primary">
                        Уншиж байна ...
                    </Button>
                    :
                    <Button color="primary" onPress={submit}>
                        Устгах
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
